// extracted by mini-css-extract-plugin
export default {"SearchInputContainer":"SearchInput_SearchInputContainer__5v9Wb"};